import React from 'react';
import FramiSvgIcon from './FramiSvgIcon';

function FrameFilledIcon(props) {
    return (
        <FramiSvgIcon {...props} viewBox="0 0 24 24">
            <path d="M2 20V4H22V20H2ZM4 18H20V6H4V18ZM6 16H18V8H6V16Z" />
        </FramiSvgIcon>
    );
}

export default FrameFilledIcon;
